export default {
  careerPage: {
    title: "Career",
    subtitle: "My Experience",
    catchphrase:
      "I am passionate about continuous learning and solving complex technical problems, and I am always looking for new challenges, new encounters, and sharing.",
    jobs: {
      informationSystemControl2024: {
        jobTitle: "Information System Control - Pharmacy-Sterilization Service",
        location: "CHRU de Strasbourg - University Hospitals of Strasbourg",
        dates: "2024",
        duration: "Today",
        description: [
          "Querying, extraction, data processing.",
          "Feeding dashboards and monitoring.",
          "Tracking, updating, and recording data related to the 'Pharmacy' market and products.",
        ],
      },
      fullStackMERN2024: {
        jobTitle: "Full-Stack Developer - MERN",
        location: "Independent Training",
        dates: "2024-2024",
        duration: "7 months",
        description: [
          "Full Stack Developer through the MERN stack (MongoDB, Express.js, React, Node.js), with extensive experience in Front-end React JS.",
        ],
      },
      frontendReactAzeon2023: {
        jobTitle: "Front-end Developer - JavaScript/React",
        location: "Azeon Agency",
        dates: "2023-2023",
        duration: "2 months",
        description: [
          "Propose an MVP of the 'job offer' page core for its client with REACT JS and REDUX technologies.",
          "A new Full Responsive Web Design, including features: advanced searches, consultation and application for offers, newsletter subscription, and highlighting 'urgent offers'.",
        ],
      },
      frontendReactOpenclassrooms2022: {
        jobTitle: "Front-end Developer - JavaScript/React",
        location: "Openclassrooms",
        dates: "2022-2023",
        duration: "1 year",
        description: [
          "Develop the Front-end of applications (SaaS / Web) and user interfaces (SPA / Web)",
        ],
      },
      userSupportTechnician2013: {
        jobTitle: "User Support Technician - IT Service",
        location: "Urssaf Alsace",
        dates: "2013-2021",
        duration: "8 years",
        description: [
          "Identify needs with the interlocutor and co-construct an appropriate solution or response.",
          "Position oneself in a service relationship with users.",
          "Provide versatile support and assistance to users on their workstations.",
          "Continuation of national work on AED.",
          "Assistance and training of users on GED tools.",
        ],
      },
      expertReferent2008: {
        jobTitle: "Expert Referent - Non-Dematerialized Incoming Flow and Image",
        location: "Urssaf Alsace",
        dates: "2008-2013",
        duration: "5 years",
        description: [
          "Deputy Pilot of the deployment project and administration of a new production chain for document dematerialization.",
          "Participation in national working groups on Electronic Document Archiving (AED) and drafting procedures.",
          "Team animation, change management, and training of agents on new tools and processes.",
          "Functional and technical administration of GED tools.",
        ],
      },
      advisorServiceOffers2005: {
        jobTitle: "Advisor - Service Offers",
        location: "Urssaf Alsace",
        dates: "2005-2008",
        duration: "3 years",
        description: [
          "Promote and monitor dematerialized services offered by the recovery network.",
          "Information and support for clients and partners.",
        ],
      },
      accountManager2001: {
        jobTitle: "Account Manager - Amicable and Forced Recovery",
        location: "Urssaf Alsace",
        dates: "2001-2005",
        duration: "4 years",
        description: [
          "Manage a portfolio of client accounts in terms of litigation and manage relationships with partners.",
          "Information and support for clients regarding their obligations and rights.",
        ],
      },
    },
  },
}
